<template>
    <div class="modal-card card">
        <header class="modal-card-head">
            <p class="modal-card-title">Select Service Type</p>
        </header>
        <div class="column is-full is-mobile has-text-weight-bold">
            <div class="columns is-mobile ">
                <div class="column is-1"></div>
                <div class="column is-one-third has-text-centered">Type</div>
                <div class="column is-half has-text-centered">Restrictions</div>
            </div>
        </div>
        <div
            class="column is-full is-mobile"
            v-for="(type,index) in serviceTypes"
            :key="type.key"
        >
            <b-collapse
                animation="slide"
                aria-id="contentIdForA11y2"
                :open="isOpen == index"
                @open="isOpen = index"
            >
                <template #trigger>
                    <b-radio-button
                        type="is-primary is-light is-outlined"
                        v-model="selectedType"
                        :native-value="type.key"
                    >
                        <span>
                            <div
                                aria-controls="contentIdForA11y2"
                                class="columns is-mobile is-vcentered"
                            >
                                <div class="column is-1">
                                    <img
                                        :src="type.imgSrc"
                                        style="max-width:150%"
                                    />
                                </div>
                                <div class="column is-one-third has-text-centered">
                                    {{type.description}}
                                </div>
                                <div class="column">{{type.restrictions}}</div>
                            </div>
                        </span>
                    </b-radio-button>
                </template>
                <b-field
                    class="pt-3 px-3"
                    label="specialRequest"
                >
                    <div class="columns is-mobile is-multiline">
                        <div
                            class="column is-4"
                            v-for="item in type.specialRequest"
                            :key="item.value"
                        >
                            <b-checkbox
                                v-model="specialRequest"
                                :native-value="item.value"
                            >
                                {{item.description}}
                            </b-checkbox>
                        </div>
                    </div>
                </b-field>
            </b-collapse>
        </div>
        <footer class="modal-card-foot">
            <b-button
                class="column is-6"
                type="is-danger"
                outlined
                expanded
                @click="onClickClose"
            >Cancel</b-button>
            <b-button
                class="column is-6"
                type="is-success"
                outlined
                expanded
                @click="onClickConfirm"
            >Confirm</b-button>
        </footer>
    </div>
</template>

<script>
import { serviceTypes } from "../settings/serviceTypes";
export default {
  name: "ServiceTypeLalamove",
  data() {
    return {
      isOpen: null,
      serviceTypes: serviceTypes,
      specialRequest: ["THERMAL_BAG_1"],
      selectedType: null,
    };
  },
  watch: {
    selectedType: {
      handler(val) {
        if (val !== "MOTORCYCLE") {
          this.specialRequest = [];
        }
      },
    },
  },
  methods: {
    onClickConfirm() {
      if (this.selectedType) {
        this.$emit("onSelect", {
          selectedType: this.selectedType,
          specialRequest: this.specialRequest,
        });
        this.$emit("close");
      } else {
        this.$buefy.toast.open({
          duration: 2000,
          message: `<i class="fas fa-exclamation-triangle"></i> โปรดเลือกรถที่ต้องการ`,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    onClickClose() {
      this.$emit("close");
    },
  },
};
</script>

<style>
/* Important part */
.modal-card {
  overflow-y: initial !important;
}
</style>